import script from "./PicturePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PicturePage.vue?vue&type=script&setup=true&lang=js"

import "./PicturePage.vue?vue&type=style&index=0&id=21c64e6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c64e6f"]])

export default __exports__